import React from "react";
import Plotly from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";

const Plot = createPlotlyComponent(Plotly);

function GeoPlot(props:{data: any, style:any, layout:any, id:any, className:any}){

  var config = {responsive: true}
    return (<>
        <Plot
        className={props.className +" w-100"}
        divId={props.id}
        data={props.data}
        useResizeHandler={true}
        style={{height: '90%'}}
        layout={ props.layout }
        config={config}
        data-id={`Graph ${props.id}`}
        data-parentid="Graph"
      />
    </>)
}

export default GeoPlot;